import { OneTimePassRoutes } from '@/portal/one-time-pass';
import { WorkerOnBoardingRoutes } from '@/portal/worker-on-boarding';

import AppContainer from '@/portal/app-container/AppContainer.vue';
import PublicInduction from '@/portal/public-induction/PublicInduction.vue';

import portalGuards from '@/portal/portal.guards';

export default [
  {
    path: '/',
    name: 'app',
    component: AppContainer,
    meta: {
      guards: [portalGuards.isAuthenticated],
    },
    children: [
      ...OneTimePassRoutes,
      ...WorkerOnBoardingRoutes,
    ],
  },
  {
    path: '/inductions',
    name: 'public-induction',
    component: PublicInduction,
  },
];
